/* eslint-disable no-unexpected-multiline */
import types from '../types'
import workflowResources from '../Workflow_Resources.json'
// import {fetchSectionResponse} from './fetchSectionResponse'
// import {fetchSubSectionResponse} from './fetchSubSectionResponse.js'

/*
  Controller for TypeForm state:
  Takes current section/subsection names/indices, current pqIdIndex,
  and requested subsection/pq/ufq indices to
  set new section/subsection names/indices, pq/ufq id's and indices,
  isEndOfSubSection, isEndofSection, & isReview

  Check for new ufq, then pq, then subSection
*/

export const changeQuestion = (props) => (dispatch, getState) => {
  console.log('here', props)
  const time = Date.now()
  function doResourcesExist(selectedSectionName, selectedSubSectionName) {
    // console.log(
    //     '/// HERE ///: ',
    //     workflowResources,
    //     selectedSectionName,
    //     selectedSubSectionName,
    // )
    return workflowResources[selectedSectionName]?.[selectedSubSectionName]
  }
  // const {
  //   documents,
  // } = getState().userReducer
  let {
    newSubSectionIndex,
    newPqIdIndex,
    newUfqIdIndex,
    currentPqId,
    currentPqIdIndex,
    currentUfqIdIndex,
    prompt1Response,
    selectedSectionIndex,
    selectedSubSectionIndex,
    // selectedSectionName,
    // selectedSubSectionName,
    isReview,
    direction,
    isSubSectionReadyForReview,
    isResourcesPage,
  } = props
  let selectedSectionName
  let selectedSubSectionName
  // console.log('change q props: ', props)
  if (isResourcesPage) {
    console.log('/// setting resources page false ///')
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        isResourcesPage: false,
        time,
      },
    })
  } else if (isSubSectionReadyForReview) {
    if (newUfqIdIndex < currentUfqIdIndex) {
      // console.log('here')
      dispatch({
        type: types.STORE_PAYLOAD,
        payload: {
          isSubSectionReadyForReview: false,
          isLoading: false,
          time,
        },
      })
    } else {
      // handled in TypeForm.js
    }
  } else if (isReview) { // subSection review
    if (direction === 'backwards') { // up arrow from review
      // go back to "You have completed this section"
      // console.log('here')
      dispatch({
        type: types.STORE_PAYLOAD,
        payload: {
          isReview: false,
          isLoading: false,
          time,
        },
      })
    } else if (direction === 'forwards') { // forward arrow from review
      // disabled for demo
      // To do: check for response, allow skipping fetch if already has response
    }
  } else { // not subSection review
    // let isResourcesPage // set true for each new subSection

    const sections = Object.keys(prompt1Response)
    selectedSectionName =
      sections[selectedSectionIndex]
    const subSections = Object.keys(prompt1Response[selectedSectionName])
    selectedSubSectionName =
      subSections[selectedSubSectionIndex]

    let currentPqs =
      prompt1Response?.
          [selectedSectionName]?.
          [selectedSubSectionName]?.
          ['Questions']
    if (!currentPqId) { // first question
      currentPqId = Object.keys(currentPqs)[currentPqIdIndex]
    }
    const currentPq = currentPqs[currentPqId]
    const currentUfqIds = Object.keys(currentPq['User Facing Question'])
    let newUfqId = currentUfqIds[newUfqIdIndex]
    // let newUfq = currentPq['User Facing Question'][newUfqId]
    if (newUfqId) { // found new ufq in current pq
      // set new ufq id/index,
      // set selected section/sub section names and pq for first question
      console.log('-----here-----', isResourcesPage)
      dispatch({
        type: types.STORE_PAYLOAD,
        payload: {
          currentUfqId: newUfqId,
          currentUfqIdIndex: newUfqIdIndex,
          currentPqId: currentPqId,
          currentPqIdIndex: currentPqIdIndex,
          isSubSectionReadyForReview: false,
          selectedSectionName,
          selectedSubSectionName,
          isLoading: false,
          isResourcesPage,
          isLastQInView: false, // handled by render
          time,
        },
      })
    } else { // requested ufq not in this pq,
      // go to new pq
      let currentPqIds = Object.keys(currentPqs)
      let newPqId = currentPqIds[newPqIdIndex]
      let newPq = currentPqs[newPqId]
      if (newPqId) { // requested pq exists in current subSection
        // set new pq id/index, ufq id/index, section/sub section names
        const newUfqIds = Object.keys(newPq['User Facing Question'])
        if (newUfqIdIndex === -1) { // user went back
          newUfqIdIndex = newUfqIds.length - 1 // last ufq
        } else { // user went forwards
          newUfqIdIndex = 0
        }
        newUfqId = newUfqIds[newUfqIdIndex]
        console.log('-----here-----')
        dispatch({
          type: types.STORE_PAYLOAD,
          payload: {
            currentUfqId: newUfqId,
            currentUfqIdIndex: newUfqIdIndex,
            currentPqId: newPqId,
            currentPqIdIndex: newPqIdIndex,
            isSubSectionReadyForReview: false,
            isLoading: false,
            isResourcesPage,
            isLastQInView: false, // handled by render
            time,
          },
        })
      } else { // requested pq does not exist in selected section/sub section
        // if newSubSection...
        const currentSectionNames =
          Object.keys(prompt1Response[selectedSectionName])

        const newSelectedSubSectionName =
          currentSectionNames[newSubSectionIndex]
        if (newSelectedSubSectionName) { // requested sub section exists
          // set new sub section, pq, ufq data
          currentPqs = prompt1Response?.
              [selectedSectionName]?.
              [newSelectedSubSectionName]?.
              ['Questions']
          currentPqIds = Object.keys(currentPqs)
          newPqIdIndex = 0
          newPqId = currentPqIds[newPqIdIndex]
          newPq = currentPqs[newPqId]
          newUfqIdIndex = 0
          const newUfqIds = Object.keys(newPq['User Facing Question'])
          const newUfqId = newUfqIds[newUfqIdIndex]
          const newIsResourcesPage = // if new min el has resources, return true
            doResourcesExist(
                selectedSectionName,
                newSelectedSubSectionName,
            )
          console.log('/// Setting isResourcesPage true ///')
          console.log('-----here-----')
          dispatch({
            type: types.STORE_PAYLOAD,
            payload: {
              isResourcesPage: newIsResourcesPage,
              selectedSubSectionIndex: newSubSectionIndex,
              selectedSubSectionName: newSelectedSubSectionName,
              currentUfqId: newUfqId,
              currentUfqIdIndex: newUfqIdIndex,
              currentPqId: newPqId,
              currentPqIdIndex: newPqIdIndex,
              isSubSectionReadyForReview: false,
              isLoading: false,
              isLastQInView: false, // handled by render
              time,
            },
          })
        } else if (newSubSectionIndex === selectedSubSectionIndex - 1) {
          // go to previous subSection
          // console.log('go to previous sub section')
        } else if (isReview) {
          // if no doc, fetch doc
          // console.log('no new sub section')
          // if (!documents?.[selectedSectionName]) {
          //   console.log('fetching doc')
          //   dispatch({
          //     type: types.STORE_PAYLOAD,
          //     payload: {
          //       isLoading: true,
          //     },
          //   })
          //   dispatch(fetchSectionResponse())
          // } else {
          //   console.log('doc obtatined, go to new section')
          // }
          // dispatch({
          //   type: types.STORE_PAYLOAD,
          //   payload: {
          //     isLoading: true,
          //     isFetchingDoc: true,
          //   },
          // })
          // dispatch({
          //   type: types.STORE_PAYLOAD,
          //   payload: {
          //     isReview: true,
          //   },
          // })
        }
      }
    }
  }
}
